export enum LandDevelopmentPotential {
  FULLY_SIUTABLE_FOR_BUILDING = 'FULLY_SIUTABLE_FOR_BUILDING',
  PARTIALY_SIUTABLE_FOR_BUILDING = 'PARTIALY_SIUTABLE_FOR_BUILDING',
  NOT_SIUTABLE_FOR_BUILDING = 'NOT_SIUTABLE_FOR_BUILDING',
  UNKNOWN = 'UNKNOWN',
}

export enum LandDevelopmentPotentialGermanString {
  FULLY_SIUTABLE_FOR_BUILDING = 'Kurzfristig bebaubar',
  PARTIALY_SIUTABLE_FOR_BUILDING = 'Eingeschränkt bebaubar ',
  NOT_SIUTABLE_FOR_BUILDING = 'Nicht bebaubar',
  UNKNOWN = 'Weiß nicht',
}
